"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReserveInstruction = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const buffer_layout_1 = require("buffer-layout");
const state_1 = require("../state");
const util_1 = require("../util");
const instruction_1 = require("./instruction");
const DataLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)("instruction"),
    (0, util_1.u64)("liquidityAmount"),
    state_1.ReserveConfigLayout,
]);
const initReserveInstruction = (liquidityAmount, config, sourceLiquidity, destinationCollateral, reserve, liquidityMint, liquiditySupply, liquidityFeeReceiver, pythProduct, pythPrice, collateralMint, collateralSupply, lendingMarket, lendingMarketAuthority, lendingMarketOwner, transferAuthority, switchboardFeed, lendingProgram) => {
    const data = Buffer.alloc(DataLayout.span);
    DataLayout.encode({
        instruction: instruction_1.LendingInstruction.InitReserve,
        liquidityAmount: BigInt(liquidityAmount),
        config,
    }, data);
    const keys = [
        //    let source_liquidity_info = next_account_info(account_info_iter)?;
        { pubkey: sourceLiquidity, isSigner: false, isWritable: true },
        //     let destination_collateral_info = next_account_info(account_info_iter)?;
        { pubkey: destinationCollateral, isSigner: false, isWritable: true },
        //     let reserve_info = next_account_info(account_info_iter)?;
        { pubkey: reserve, isSigner: false, isWritable: true },
        //     let reserve_liquidity_mint_info = next_account_info(account_info_iter)?;
        { pubkey: liquidityMint, isSigner: false, isWritable: false },
        //     let reserve_liquidity_supply_info = next_account_info(account_info_iter)?;
        { pubkey: liquiditySupply, isSigner: false, isWritable: true },
        //     let reserve_liquidity_fee_receiver_info = next_account_info(account_info_iter)?;
        { pubkey: liquidityFeeReceiver, isSigner: false, isWritable: true },
        //     let reserve_collateral_mint_info = next_account_info(account_info_iter)?;
        { pubkey: collateralMint, isSigner: false, isWritable: true },
        //     let reserve_collateral_supply_info = next_account_info(account_info_iter)?;
        { pubkey: collateralSupply, isSigner: false, isWritable: true },
        //     let pyth_product_info = next_account_info(account_info_iter)?;
        { pubkey: pythProduct, isSigner: false, isWritable: false },
        //     let pyth_price_info = next_account_info(account_info_iter)?;
        { pubkey: pythPrice, isSigner: false, isWritable: false },
        //     let switchboard_feed_info = next_account_info(account_info_iter)?;
        { pubkey: switchboardFeed, isSigner: false, isWritable: false },
        //     let lending_market_info = next_account_info(account_info_iter)?;
        { pubkey: lendingMarket, isSigner: false, isWritable: true },
        //     let lending_market_authority_info = next_account_info(account_info_iter)?;
        { pubkey: lendingMarketAuthority, isSigner: false, isWritable: false },
        //     let lending_market_owner_info = next_account_info(account_info_iter)?;
        { pubkey: lendingMarketOwner, isSigner: true, isWritable: false },
        //     let user_transfer_authority_info = next_account_info(account_info_iter)?;
        { pubkey: transferAuthority, isSigner: true, isWritable: false },
        //     let clock = &Clock::from_account_info(next_account_info(account_info_iter)?)?;
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
        //     let rent_info = next_account_info(account_info_iter)?;
        //     let rent = &Rent::from_account_info(rent_info)?;
        { pubkey: web3_js_1.SYSVAR_RENT_PUBKEY, isSigner: false, isWritable: false },
        //     let token_program_id = next_account_info(account_info_iter)?;
        { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: lendingProgram,
        data,
    });
};
exports.initReserveInstruction = initReserveInstruction;
